module.exports = __webpack_public_path__ + "static/media/landing_org_sydney.d5dee07a.png";